import React from 'react';
import './TriStateCheckbox.scss';

interface TriStateCheckboxProps {
  checked: boolean;
  indeterminate?: boolean | undefined;
  showX?: boolean;
  checkboxLabel?: string;
  onClick: any;
  disabled?: boolean;
}

export default function TriStateCheckbox({
  checked,
  indeterminate,
  showX = false,
  checkboxLabel,
  onClick,
  disabled = false,
}: TriStateCheckboxProps) {
  return (
    <div className="tri-state-checkbox" onClick={disabled ? () => {} : onClick}>
      <div className="tri-state-checkbox-box">
        {indeterminate ? (
          <span className="indeterminate">
            <i className="icon fas fa-minus"></i>
          </span>
        ) : checked ? (
          <span className="checked">
            <i className={`icon fas ${showX ? 'fa-times' : 'fa-check'}`}></i>
          </span>
        ) : null}
      </div>
      <span
        className={`tri-state-checkbox-label${disabled ? ' disabled' : ''}`}
      >
        {checkboxLabel}
      </span>
    </div>
  );
}
